import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class DataBox extends React.Component {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        const { isOpen } = this.props;
        const { dataStock, prices, hash, current } = this.props.content;

        if (dataStock && prices.length > 0) {
            return (
                <div className={styles.data_box}>
                    <a href={dataStock[current].url} target="_blank" rel="rel noreferrer">
                        <h3>{dataStock[current].name}</h3>
                    </a>
                    <p>
                        <a href={dataStock[current].url} target="_blank" rel={rel}>
                            <img src={`${dataStock[current].img}?${hash}`} width="300" height="163" />
                        </a>
                    </p>
                    <div className={prices[current].percent < 0 ? styles.green : ''}>
                        <p>
                            <a
                                href={dataStock[current].url}
                                target="_blank"
                                rel={rel}
                                alt={dataStock[current].name}
                                title={dataStock[current].name}>
                                {dataStock[current].name}
                            </a>
                        </p>
                        {isOpen ? <p>{prices[current].price}</p> : <p style={{ color: '#273766' }}>--</p>}
                        {isOpen ? <p>{prices[current].width}</p> : <p style={{ color: '#273766' }}>--</p>}
                        {isOpen ? <p>{prices[current].percent}%</p> : <p style={{ color: '#273766' }}>--</p>}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default errorBoundary(DataBox);
